module.exports = __webpack_public_path__ + "static/media/antenatiBortoloBurei.a4dcff11.jpg";